export const translation = {
  common: {
    logout: 'Odjava',
    account: 'Nalog',
    myAccount: 'Moj nalog',
    search: 'Pretraži...',
    actions: 'Akcije',
    view: 'Pregledaj',
    edit: 'Izmeni',
    delete: 'Obriši',
    save: 'Sačuvaj',
    saving: 'Čuvanje...',
    deleting: 'Brisanje...',
    cancel: 'Odustani',
    close: 'Zatvori',
    back: 'Nazad',
    backToList: 'Nazad na listu',
    backToVehicles: 'Nazad na vozila',
    new: 'Novo',
    create: 'Kreiraj',
    list: 'Lista',
    none: 'Nijedno',
    all: 'Sve',
    noResults: 'Nema rezultata',
    rowsPerPage: 'Redova po stranici:',
    viewVehicle: 'Pogledaj vozilo',
    loading: 'Učitavanje...',
    error: 'Greška',
    success: 'Uspješno',
    required: 'Obavezno polje',
    activeContracts: 'Aktivni ugovori',
    viewAll: 'Pregledaj sve',
    errorLoadingData: 'Greška pri učitavanju podataka',
    unlimited: 'Neograničeno',
    validation: {
      // Required fields
      required: 'Ovo polje je obavezno',

      // String validation
      minLength: 'Minimalna dužina je {{min}} karaktera',
      maxLength: 'Maksimalna dužina je {{max}} karaktera',
      exactLength: 'Dužina mora biti tačno {{length}} karaktera',

      // Number validation
      min: 'Minimalna vrednost je {{min}}',
      max: 'Maksimalna vrednost je {{max}}',
      positive: 'Vrednost mora biti pozitivan broj',
      nonNegative: 'Vrednost ne može biti negativna',
      integer: 'Vrednost mora biti ceo broj',

      // Format validation
      invalidEmail: 'Nevažeća email adresa',
      invalidPhone: 'Nevažeći broj telefona',
      invalidUrl: 'Nevažeći URL',
      invalidDate: 'Nevažeći datum',

      // Date validation
      dateInPast: 'Datum mora biti u prošlosti',
      dateInFuture: 'Datum mora biti u budućnosti',
      dateTodayOrFuture: 'Datum mora biti danas ili u budućnosti',
      dateAfter: 'Datum mora biti posle {{date}}',
      dateBefore: 'Datum mora biti pre {{date}}',
      endDateAfterStartDate: 'Datum završetka mora biti posle datuma početka',

      // Custom validations
      duplicate: 'Ova vrednost već postoji',
      notFound: 'Vrednost nije pronađena',
      invalidFormat: 'Nevažeći format',

      // General
      invalidValue: 'Nevažeća vrednost',
    },
    errors: {
      // General errors
      saveFailed: 'Greška pri čuvanju podataka',
      loadFailed: 'Greška pri učitavanju podataka',
      deleteFailed: 'Greška pri brisanju',
      unauthorized: 'Nemate dozvolu za ovu akciju',
      networkError: 'Greška u mreži. Proverite internet konekciju',
      unknownError: 'Došlo je do nepoznate greške',
      validationErrors: 'Molimo ispravite sledeće greške:',
    },
  },
  language: {
    latin: 'Latinica',
    cyrillic: 'Ćirilica',
  },
  roles: {
    systemAdmin: 'Sistem Administrator',
    companyAdmin: 'Direktor',
    fleetManager: 'Menadžer',
    fleetUser: 'Korisnik',
    contractManager: 'Menadžer ugovora',
    userAdmin: 'Administrator korisnika',
  },
  nav: {
    dashboard: 'Kontrolna tabla',
  },
  modules: {
    fleet: {
      name: 'Vozni park',
    },
    users: {
      name: 'Korisnici',
    },
  },
  fleets: {
    dashboard: {
      subtitle: 'Pregled voznog parka',
    },
    nav: {
      vehicles: 'Vozila',
      allVehicles: 'Sva vozila',
      requests: 'Zahtevi',
      operations: 'Operacije',
      services: 'Servisi',
      fuel: 'Gorivo',
      tires: 'Gume',
      registrations: 'Registracije',
      contracts: 'Ugovori',
      activeContracts: 'Aktivni ugovori',
      providers: 'Dobavljači',
      travelOrders: 'Vožnje',
      travelOrderPeriods: 'Putni nalozi',
      fleetUsers: 'Korisnici',
      myAccount: 'Moj nalog',
      reports: 'Izvještaji',
      tireTracking: 'Evidencija guma',
    },
    vehicles: {
      title: 'Vozila',
      subtitle: 'Jednostavan uvid u detalje vozila',
      add: 'Dodaj vozilo',
      addVehicle: 'Dodaj novo vozilo',
      editVehicle: 'Izmeni vozilo',
      notFound: 'Vozilo nije pronađeno',
      basicInfoButton: 'Podaci',
      registration: 'Registarska oznaka',
      assignedTo: 'Zadužio',
      brand: 'Marka',
      model: 'Model',
      type: 'Tip',
      year: 'Godina',
      status: 'Status',
      requestPriority: 'Prioritet',
      color: 'Boja',
      chassisNumber: 'Broj šasije',
      engineNumber: 'Broj motora',
      enginePower: 'Snaga motora',
      fuelType: 'Tip goriva',
      mileage: 'Kilometraža',
      registrationNumber: 'Broj saobraćajne',
      registrationDate: 'Datum registracije',
      registrationExpiry: 'Istek registracije',
      generalInfo: 'Opšti podaci',
      registrationInfo: 'Registracija',
      vehicleIsRegistered: 'Vozilo je registrovano',
      technicalInfo: 'Tehnički podaci',
      serviceHistory: 'Istorija servisa',
      fuelLogs: 'Evidencija goriva',
      noServiceHistory: 'Nema istorije servisa',
      noFuelLogs: 'Nema evidencije goriva',
      noDocuments: 'Nema dokumenata',
      tabs: {
        basicInfo: 'Osnovni podaci',
        services: 'Servisi',
        registrations: 'Registracije',
        fuel: 'Gorivo',
        assigmnets: 'Dodele',
      },
      // Form field labels (matching English property names)
      fields: {
        plateNumber: 'Registarska oznaka',
        brand: 'Marka',
        model: 'Model',
        vehicleType: 'Tip vozila',
        productionDate: 'Datum proizvodnje',
        chassisNumber: 'Broj šasije',
        registrationNumber: 'Broj saobraćajne',
        registrationDate: 'Datum registracije',
        registrationExpiry: 'Istek registracije',
        wheelDimension: 'Dimenzija točka',
        odometer: 'Kilometraža',
        engineNumber: 'Broj motora',
        powerKW: 'Snaga motora (kW)',
        capacityCM3: 'Zapremina (cm³)',
        fuelType: 'Tip goriva',
        color: 'Boja',
        passengerSeats: 'Broj sedišta',
        fuelCardNumber: 'Broj kartice za gorivo',
        currentDriverId: 'Zaposleni',
        requestPriority: 'Prioritet zahteva',
      },
      vehicleTypes: {
        Passenger: 'Putnički',
        Cargo: 'Teretni',
        Special: 'Specijalni',
        Work: 'Radni',
        Trailer: 'Priključno',
      },
      availability: {
        title: 'Dostupnost vozila',
        errorLoading: 'Greška pri učitavanju podataka o dostupnosti',
        free: 'Slobodno',
        hoursOf24: '{{hours}}h od 24h ({{percent}}%)',
        eventTypes: {
          travelOrder: 'Zauzeto',
          service: 'Servis',
          outOfService: 'Van funkcije',
          manual: 'Rezervacija',
          unavailable: 'Nedostupno',
        },
      },
    },
    services: {
      title: 'Servisi',
      subtitle: 'Pregled i upravljanje servisima vozila',
      add: 'Novi servis',
      create: 'Novi servis',
      edit: 'Izmeni servis',
      pending: 'na čekanju',
      loading: 'Učitavanje servisa...',
      notFound: 'Servis nije pronađen ili je došlo do greške pri učitavanju.',
      errorLoading: 'Greška pri učitavanju servisa. Pokušajte ponovo.',
      notSpecified: 'Nije navedeno',
      viewVehicle: 'Pogledaj vozilo',

      // Table columns
      vehicle: 'Vozilo',
      type: 'Tip',
      description: 'Opis',
      scheduledDate: 'Datum',
      provider: 'Serviser',
      cost: 'Trošak',
      status: 'Status',

      // Form sections
      form: {
        basicInfo: 'Osnovni podaci',
        providerSection: 'Dobavljač / Serviser',
        invoiceSection: 'Faktura i napomene',
        itemsSection: 'Stavke servisa',
        notesSection: 'Napomene',
        newService: 'Novi servis',
        editService: 'Izmeni servis',
      },

      // Fields
      fields: {
        vehicle: 'Vozilo',
        odometerReading: 'Stanje kilometraže',
        description: 'Opis servisa',
        descriptionPlaceholder: 'Npr. Redovan servis 30.000 km - zamena ulja i filtera',
        provider: 'Dobavljač',
        providerNotSelected: 'Nije odabrano',
        providerNone: 'Nije odabrano',
        contract: 'Ugovor',
        customProviderName: 'Naziv servisera (ručni unos)',
        invoiceNumber: 'Broj fakture',
        notes: 'Napomene',
        notesPlaceholder: 'Dodatne napomene o servisu...',
      },

      // Detail page
      detail: {
        basicInfo: 'Osnovni podaci',
        vehicle: 'Vozilo',
        odometer: 'Kilometraža',
        createdAt: 'Datum kreiranja',
        updatedAt: 'Datum izmene',
        invoiceNumber: 'Broj fakture',
        provider: 'Dobavljač',
        totalCost: 'Ukupan trošak',
        notes: 'Napomene',
        items: 'Stavke servisa',
        itemCount: 'stavka',
        itemsCount: 'stavki',
      },

      // Service items
      items: {
        title: 'Stavke servisa',
        add: 'Dodaj stavku',
        addButton: 'Dodaj',
        edit: 'Izmeni stavku',
        editTooltip: 'Izmeni',
        delete: 'Obriši stavku',
        deleteTooltip: 'Obriši',
        noItems: 'Nema stavki',
        noItemsHint: 'Kliknite "Dodaj stavku" da dodate prvu stavku servisa',
        noItemsHintMobile: 'Kliknite "Dodaj" da dodate prvu stavku servisa',
        noItemsDetail: 'Ovaj servis nema dodanih stavki',
        total: 'Ukupno',
        totalLabel: 'UKUPNO:',

        // Table columns
        type: 'Tip',
        description: 'Opis',
        quantity: 'Kol.',
        quantityFull: 'Količina',
        unitPrice: 'Cena',
        unitPriceFull: 'Cena po jedinici',
        totalPrice: 'Ukupno',
        actions: 'Akcije',

        // Item types
        types: {
          Other: 'Ostalo',
          Work: 'Rad',
          Part: 'Deo',
          Tire: 'Guma',
          Fee: 'Naknada',
        },
      },

      // Add/Edit item dialog
      itemDialog: {
        addTitle: 'Dodaj stavku',
        editTitle: 'Izmeni stavku',
        itemType: 'Tip stavke',
        description: 'Opis',
        descriptionPlaceholder: 'Npr. Zamena ulja i filtera',
        quantity: 'Količina',
        unitPrice: 'Cena po jedinici',
        unitPriceHint: 'Sa PDV-om (bruto)',
        tireDetails: 'Detalji gume',
        tireType: 'Tip gume',
        tireAction: 'Akcija',
        tireSize: 'Dimenzija',
        tireSizePlaceholder: '205/55R16',
        tireDiameter: 'Prečnik (felne)',
        tireDotCode: 'DOT kod (opciono)',
        tireDotCodePlaceholder: '2423',
        tireDotCodeHint: 'Sedmica i godina proizvodnje (npr. 2423 = 24. sedmica 2023)',
        save: 'Sačuvaj izmene',
        add: 'Dodaj',
        cancel: 'Otkaži',
        validationError: 'Molimo ispravite sledeće greške:',

        // Validation messages
        fieldRequired: 'Ovo polje je obavezno',
        quantityMustBePositive: 'Količina mora biti veća od 0',
        priceMustBeNonNegative: 'Cena mora biti 0 ili veća',
      },

      // Tire types
      tireTypes: {
        Summer: 'Letnja',
        Winter: 'Zimska',
        AllSeason: 'Celogodišnja',
      },

      // Tire actions
      tireActions: {
        Other: 'Ostalo',
        GroupAction: 'Grupna akcija',
        Purchase: 'Kupovina',
        Replace: 'Zamena',
        Storage: 'Skladištenje',
        Dispose: 'Otpis',
      },

      // Actions
      actions: {
        viewVehicle: 'Pogledaj vozilo',
        edit: 'Izmeni',
        delete: 'Obriši',
        save: 'Sačuvaj',
        saving: 'Čuvanje...',
        cancel: 'Otkaži',
      },

      // Validation
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        odometerRequired: 'Stanje kilometraže je obavezno',
        odometerPositive: 'Stanje kilometraže mora biti pozitivan broj',
        odometerCannotDecrease: 'Stanje kilometraže ne može biti manje od trenutnog stanja vozila ({{current}} km). Uneli ste: {{provided}} km',
        descriptionRequired: 'Opis je obavezan',
        descriptionMinLength: 'Opis mora imati najmanje 10 karaktera',
        itemTypeRequired: 'Tip stavke je obavezan',
        itemDescriptionRequired: 'Opis stavke je obavezan',
        quantityRequired: 'Količina je obavezna',
        quantityPositive: 'Količina mora biti pozitivan broj',
        unitPriceRequired: 'Cena je obavezna',
        unitPricePositive: 'Cena mora biti pozitivan broj',
        tireSizeRequired: 'Dimenzija gume je obavezna',
        tireDiameterRequired: 'Prečnik gume je obavezan',
        invoiceNumberRequired: 'Broj fakture je obavezan',
        contractRequired: 'Ugovor je obavezan kada je odabran dobavljač',
        customProviderNameRequired: 'Naziv servisera je obavezan kada dobavljač nije odabran',
        itemsRequired: 'Bar jedna stavka je obavezna',
      },

      // Helper texts
      helpers: {
        currentOdometer: 'Trenutno stanje: {{odometer}} km',
      },

      // Success messages
      success: {
        created: 'Servis je uspješno kreiran',
        updated: 'Servis je uspješno ažuriran',
        deleted: 'Servis je uspješno obrisan',
        itemAdded: 'Stavka je uspješno dodata',
        itemUpdated: 'Stavka je uspješno ažurirana',
        itemDeleted: 'Stavka je uspješno obrisana',
      },

      // Error messages
      errors: {
        createFailed: 'Greška pri kreiranju servisa',
        updateFailed: 'Greška pri ažuriranju servisa',
        deleteFailed: 'Greška pri brisanju servisa',
        loadFailed: 'Greška pri učitavanju servisa',
        itemAddFailed: 'Greška pri dodavanju stavke',
        itemUpdateFailed: 'Greška pri ažuriranju stavke',
        itemDeleteFailed: 'Greška pri brisanju stavke',
      },

      // Dialogs
      deleteConfirmTitle: 'Obriši servis',
      deleteConfirmMessage: 'Da li ste sigurni da želite da obrišete ovaj servis? Ova akcija se ne može poništiti.',
      deleteItemTitle: 'Obriši stavku',
      deleteItemMessage: 'Da li ste sigurni da želite da obrišete ovu stavku?',
    },
    providers: {
      title: 'Dobavljači',
      subtitle: 'Pregled dobavljača za vozni park',
      create: 'Novi dobavljač',
      edit: 'Izmeni dobavljača',
      notFound: 'Dobavljač nije pronađen',
      viewAllServiceTypes: 'Prikaži sve tipove usluga',
      search: 'Pretraži dobavljače...',
      noResults: 'Nema dobavljača koji odgovaraju pretrazi',
      empty: 'Nema dobavljača',
      fields: {
        name: 'Naziv',
        serviceTypes: 'Tipovi usluga',
        contactEmail: 'Email',
        contactPhone: 'Telefon',
        address: 'Adresa',
        taxId: 'PIB',
        notes: 'Napomene',
        activeContracts: 'Aktivni ugovori',
      },
      serviceTypes: {
        Service: 'Servis',
        Repair: 'Popravka',
        Tire: 'Gume',
        Fuel: 'Gorivo',
        Registration: 'Registracija',
        TechnicalInspection: 'Tehnički pregled',
        Insurance: 'Osiguranje',
        Cleaning: 'Čišćenje',
        Other: 'Ostalo',
      },
      details: {
        info: 'Informacije o dobavljaču',
        contracts: 'Ugovori',
        noContracts: 'Nema ugovora',
      },
    },
    contracts: {
      title: 'Ugovori',
      subtitle: 'Pregled ugovora vezanih za vozni park',
      create: 'Novi ugovor',
      edit: 'Izmeni ugovor',
      notFound: 'Ugovor nije pronađen',
      search: 'Pretraži ugovore...',
      noResults: 'Nema ugovora koji odgovaraju pretrazi',
      empty: 'Nema ugovora',
      add: 'Novi ugovor',
      number: 'Broj ugovora',
      type: 'Tip',
      supplier: 'Dobavljač',
      vehicle: 'Vozilo',
      startDate: 'Početak',
      endDate: 'Istek',
      value: 'Vrijednost',
      status: 'Status',
      expiringWarning: '{{count}} ugovor(a) ističe uskoro',
      expiredWarning: '{{count}} ugovor(a) je isteklo',
      viewProvider: 'Pogledaj dobavljača',
      viewAllScopes: 'Prikaži sve obuhvate',
      fields: {
        providerId: 'Dobavljač',
        provider: 'Dobavljač',
        contractNumber: 'Broj ugovora',
        scopes: 'Obuhvat',
        validFrom: 'Važeći od',
        validTo: 'Važeći do',
        contractAmountNet: 'Iznos ugovora (bez PDV-a)',
        contractAmountNetShort: 'Iznos (NET)',
        vatRate: 'Stopa PDV-a',
        contractAmountGross: 'Iznos ugovora (sa PDV-om)',
        contractAmountGrossShort: 'Iznos (BRUTO)',
        remainingAmountGrossShort: 'Preostalo (BRUTO)',
        contractAmountHint: 'Unesite iznos ugovora sa PDV-om',
        consumedAmountNet: 'Potrošeno (NET)',
        consumedAmountGross: 'Potrošeno (BRUTO)',
        remainingAmountNet: 'Preostalo (NET)',
        remainingAmountGross: 'Preostalo (BRUTO)',
        status: 'Status',
        notes: 'Napomene',
      },
      details: {
        info: 'Informacije o ugovoru',
      },
      scopes: {
        Service: 'Servis',
        Repair: 'Popravka',
        Tire: 'Gume',
        Fuel: 'Gorivo',
        Registration: 'Registracija',
        TechnicalInspection: 'Tehnički pregled',
        Insurance: 'Osiguranje',
        Cleaning: 'Čišćenje',
        Other: 'Ostalo',
      },
      statuses: {
        Draft: 'Nacrt',
        Active: 'Aktivan',
        Expired: 'Istekao',
        Terminated: 'Raskinut',
      },
      expiringSoon: 'Ističe uskoro',
    },
    tireProcurement: {
      title: 'Nabavka guma',
      subtitle: 'Pregled nabavki guma za vozni park',
      add: 'Nova nabavka',
      inProgress: 'u toku',
      activeCount: '{{count}} aktivna nabavka(e) u toku',
      number: 'Broj nabavke',
      vehicle: 'Vozilo',
      type: 'Tip gume',
      size: 'Dimenzija',
      quantity: 'Količina',
      supplier: 'Dobavljač',
      date: 'Datum',
      price: 'Cijena',
      status: 'Status',
    },
    travelOrders: {
      title: 'Vožnje',
      fields: {
        orderNumber: 'Broj vožnje',
        vehiclePlateNumber: 'Registarska oznaka',
        purpose: 'Svrha',
        destination: 'Destinacija',
        plannedStartDate: 'Planirani početak',
        plannedEndDate: 'Planirani završetak',
        status: 'Status',
      },
      adjustOdometer: {
        button: 'Korekcija kilometraže',
        title: 'Korekcija kilometraže vožnje',
        info: 'Ručna korekcija stanja kilometraže za završenu ili zatvorenu vožnju. Vrijednost na vozilu se ne mijenja automatski.',
        currentStart: 'Trenutna početna: {{value}} km',
        currentEnd: 'Trenutna završna: {{value}} km',
        newStartLabel: 'Nova početna kilometraža',
        newEndLabel: 'Nova završna kilometraža',
        reasonLabel: 'Razlog korekcije',
        reasonHelper: 'Obavezno: Unesite razlog za korekciju kilometraže',
        submit: 'Sačuvaj korekciju',
        submitting: 'Spremanje...',
        cancel: 'Odustani',
        validation: {
          atLeastOneRequired: 'Unesite novu početnu ili završnu kilometražu',
          negative: 'Kilometraža ne može biti negativna',
          endLessThanStart: 'Završna kilometraža ne može biti manja od početne',
          unchanged: 'Nove vrijednosti su iste kao trenutne',
          reasonRequired: 'Razlog korekcije je obavezan',
          reasonTooLong: 'Razlog ne može biti duži od 500 karaktera',
        },
      },
    },
    travelOrderPeriods: {
      adjustOdometer: {
        button: 'Korekcija kilometraže',
        title: 'Korekcija kilometraže perioda',
        info: 'Ručna korekcija početne i/ili završne kilometraže zatvorenog perioda. Vrijednost na vozilu i susjednim periodima se ne mijenja automatski.',
        currentStart: 'Trenutna početna: {{value}} km',
        currentEnd: 'Trenutna završna: {{value}} km',
        newStartLabel: 'Nova početna kilometraža',
        newEndLabel: 'Nova završna kilometraža',
        optionalHelper: 'Opcionalno — popunite samo polje koje korigujete',
        reasonLabel: 'Razlog korekcije',
        reasonHelper: 'Obavezno: Unesite razlog za korekciju kilometraže',
        submit: 'Sačuvaj korekciju',
        submitting: 'Spremanje...',
        cancel: 'Odustani',
        chain: {
          title: 'Upozorenje o doslednosti perioda',
          previousMismatch: 'Završna kilometraža prethodnog perioda ({{prev}} km) se ne poklapa sa početnom ovog perioda ({{current}} km).',
          nextMismatch: 'Završna kilometraža ovog perioda ({{current}} km) se ne poklapa sa početnom sljedećeg perioda ({{next}} km).',
        },
        validation: {
          required: 'Unesite ispravnu vrijednost',
          negative: 'Kilometraža ne može biti negativna',
          lessThanStart: 'Završna kilometraža ne može biti manja od početne ({{start}} km)',
          endLessThanStart: 'Završna kilometraža ne može biti manja od početne ({{start}} km)',
          unchanged: 'Nova vrijednost je ista kao trenutna',
          atLeastOne: 'Morate unijeti barem jednu vrijednost: početnu ili završnu kilometražu',
          reasonRequired: 'Razlog korekcije je obavezan',
          reasonTooLong: 'Razlog ne može biti duži od 500 karaktera',
        },
      },
    },
    trips: {
      title: 'Vožnje',
    },
    reports: {
      title: 'Izvještaji',
    },
    requests: {
      title: 'Svi zahtjevi',
      subtitle: 'Pregled i odobravanje zahtjeva za izmjene vozila',
      pendingCount: '{{count}} zahtjev(a) čeka odobrenje',
      noRequests: 'Nema zahtjeva',
      vehicle: 'Vozilo',
      type: 'Tip',
      field: 'Polje',
      oldValue: 'Stara vrijednost',
      newValue: 'Nova vrijednost',
      submittedBy: 'Podnosilac',
      date: 'Datum',
      status: 'Status',
      approve: 'Odobri',
      reject: 'Odbij',
    },
    vehicleRequests: {
      title: 'Zahtjevi za vozila',
      subtitle: 'Pregled i upravljanje zahtjevima za korišćenje vozila',
      create: 'Novi zahtjev',
      add: 'Novi zahtjev',
      details: 'Detalji zahtjeva',
      loading: 'Učitavanje zahtjeva...',
      notFound: 'Zahtjev nije pronađen ili je došlo do greške pri učitavanju.',

      // Tabs
      tabs: {
        all: 'Svi zahtjevi',
        my: 'Moji zahtjevi',
        pending: 'Na čekanju',
      },

      // Table columns
      columns: {
        vehicle: 'Vozilo',
        purpose: 'Svrha',
        period: 'Period',
        requester: 'Podnosilac',
        status: 'Status',
        actions: 'Akcije',
      },

      // Registration warnings (informative only - do not block approval)
      registrationWarning: {
        missing: 'Vozilo nema evidentiranu registraciju. Provjerite dokumentaciju prije odobrenja.',
        startsLate:
          'Registracija vozila važi tek od {{validFrom}}, a zahtjev počinje ranije. Provjerite dokumentaciju prije odobrenja.',
        expiresEarly:
          'Registracija vozila ističe {{validTo}}, prije kraja traženog perioda. Provjerite dokumentaciju prije odobrenja.',
      },

      // Form
      form: {
        title: 'Novi zahtjev za vozilo',
        subtitle: 'Popunite formu da biste zatražili vozilo za određenu svrhu',
        vehicleSelection: 'Odabir vozila',
        purposeSection: 'Svrha zahtjeva',
        periodSection: 'Period i destinacija',
        additionalInfo: 'Dodatne informacije',
        preselectedVehicle: 'Vozilo je već odabrano:',
        selectVehicle: 'Odaberite vozilo',
        purposeHint: 'Opišite svrhu korišćenja vozila (minimum 10 karaktera)',
        purposePlaceholder: 'Npr. Službeno putovanje u Beograd - sastanak sa klijentom',
        destinationPlaceholder: 'Npr. Beograd, Srbija',
        estimatedDistancePlaceholder: 'Npr. 250',
        notesPlaceholder: 'Dodatne napomene ili zahtevi...',
        submit: 'Pošalji zahtjev',
        submitting: 'Slanje...',
      },

      // Fields
      fields: {
        vehicle: 'Vozilo',
        vehiclePlateNumber: 'Registarska oznaka',
        vehicleDescription: 'Opis vozila',
        requester: 'Podnosilac zahtjeva',
        purpose: 'Svrha',
        destination: 'Destinacija',
        estimatedDistance: 'Procenjena distanca',
        requestedStartDate: 'Datum početka',
        requestedEndDate: 'Datum završetka',
        startDate: 'Datum početka',
        endDate: 'Datum završetka',
        duration: 'Trajanje',
        notes: 'Napomene',
        status: 'Status',
        approver: 'Odobrio',
        approvalDate: 'Datum odobrenja',
        rejectionDate: 'Datum odbijanja',
        rejectionReason: 'Razlog odbijanja',
        cancellationDate: 'Datum otkazivanja',
        cancellationReason: 'Razlog otkazivanja',
        createdAt: 'Kreirano',
        travelOrder: 'Vožnja',
      },

      // Statuses
      statuses: {
        pending: 'Na čekanju',
        approved: 'Odobren',
        rejected: 'Odbijen',
        cancelled: 'Otkazan',
        completed: 'Završen',
      },

      // Sections
      sections: {
        summary: 'Pregled zahtjeva',
        details: 'Detalji zahtjeva',
        decision: 'Informacije o odluci',
        timeline: 'Vremenska linija',
      },

      // Actions
      actions: {
        approve: 'Odobri',
        reject: 'Odbij',
        cancel: 'Otkaži',
        view: 'Pregledaj',
        viewVehicle: 'Pogledaj vozilo',
        back: 'Nazad',
      },

      // Dialogs
      dialogs: {
        approveTitle: 'Odobri zahtjev za vozilo',
        approveMessage: 'Da li ste sigurni da želite da odobrite ovaj zahtjev?',
        approveDetails: 'Detalji zahtjeva:',
        approveConfirm: 'Odobri zahtjev',
        approveConfirming: 'Odobravanje...',
        approveSuccess: 'Zahtjev je uspješno odobren',

        rejectTitle: 'Odbij zahtjev za vozilo',
        rejectMessage: 'Molimo unesite razlog odbijanja zahtjeva.',
        rejectDetails: 'Detalji zahtjeva:',
        rejectReason: 'Razlog odbijanja',
        rejectReasonPlaceholder: 'Npr. Vozilo je već rezervisano za taj period...',
        rejectReasonHint: 'Minimalno 10 karaktera',
        rejectConfirm: 'Odbij zahtjev',
        rejectConfirming: 'Odbijanje...',
        rejectSuccess: 'Zahtjev je uspješno odbijen',

        cancelTitle: 'Otkaži zahtjev za vozilo',
        cancelMessage: 'Molimo unesite razlog otkazivanja zahtjeva.',
        cancelDetails: 'Detalji zahtjeva:',
        cancelReason: 'Razlog otkazivanja',
        cancelReasonPlaceholder: 'Npr. Putovanje je otkazano zbog promena planova...',
        cancelReasonHint: 'Minimalno 10 karaktera',
        cancelConfirm: 'Otkaži zahtjev',
        cancelConfirming: 'Otkazivanje...',
        cancelSuccess: 'Zahtjev je uspješno otkazan',
        cancelDisabledTooltip: 'Odobreni zahtjevi ne mogu biti otkazani. Molimo otkažite vožnju umjesto toga.',
      },

      // Messages
      messages: {
        period: 'Period',
        days: 'dana',
        day: 'dan',
        km: 'km',
        travelOrderCreated: 'Vožnja je kreirana za ovaj zahtjev. ID: {{id}}',
      },

      // Validation
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        purposeRequired: 'Svrha je obavezna',
        purposeMinLength: 'Svrha mora imati najmanje 10 karaktera',
        startDateRequired: 'Datum početka je obavezan',
        endDateRequired: 'Datum završetka je obavezan',
        startDateTodayOrFuture: 'Datum početka mora biti danas ili u budućnosti',
        endDateAfterStartDate: 'Datum završetka mora biti posle datuma početka',
        estimatedDistancePositive: 'Procenjena kilometraža mora biti pozitivan broj',
        reasonRequired: 'Razlog je obavezan',
        reasonMinLength: 'Razlog mora imati najmanje 10 karaktera',
      },
    },
    registrations: {
      title: 'Registracije',
      subtitle: 'Pregled i upravljanje registracijama vozila',
      create: 'Nova registracija',
      createRegistration: 'Nova registracija',
      editRegistration: 'Izmeni registraciju',
      noRegistrations: 'Nema registracija',
      notFound: 'Registracija nije pronađena',
      loading: 'Učitavanje registracije...',
      costPending: 'Bez troškova',
      costPendingHint: 'Registracija je uneta bez iznosa i fakture — dopuniti kroz Izmenu.',

      // Form sections
      generalInfo: 'Opšti podaci',
      costInfo: 'Podaci o troškovima',
      providerInfo: 'Informacije o dobavljaču',
      additionalInfo: 'Dodatne informacije',

      // Form fields
      fields: {
        vehicle: 'Vozilo',
        validFrom: 'Važi od',
        validTo: 'Važi do',
        registrationDate: 'Datum registracije',
        registrationExpiry: 'Istek registracije',
        registrationNumber: 'Broj saobraćajne',
        odometerReading: 'Kilometraža',
        cost: 'Trošak',
        invoiceNumber: 'Broj fakture',
        provider: 'Dobavljač',
        contract: 'Ugovor',
        customProviderName: 'Naziv dobavljača (ručni unos)',
        description: 'Opis',
        notes: 'Napomene',
        updateVehicleRegistration: 'Ažuriraj registraciju vozila',
      },

      // Placeholders
      notesPlaceholder: 'Opcione napomene o registraciji...',

      // Table columns
      columns: {
        vehiclePlate: 'Registarska oznaka',
        validFrom: 'Važi od',
        expiryDate: 'Datum isteka',
        cost: 'Trošak',
        provider: 'Dobavljač',
        status: 'Status',
      },

      // Filters
      filters: {
        vehicle: 'Vozilo',
        provider: 'Dobavljač',
        status: 'Status',
        dateFrom: 'Datum od',
        dateTo: 'Datum do',
      },

      // Detail page
      details: {
        basicInfo: 'Osnovni podaci',
        vehicleDetails: 'Detalji vozila',
        providerInfo: 'Informacije o dobavljaču/ugovoru',
        costDetails: 'Detalji troškova',
        notes: 'Napomene',
        vehiclePlate: 'Registarska oznaka',
        validFrom: 'Važi od',
        validTo: 'Važi do',
        registrationDate: 'Datum registracije',
        expiryDate: 'Datum isteka',
        status: 'Status',
        description: 'Opis',
        odometerReading: 'Kilometraža',
        registrationNumber: 'Broj saobraćajne',
        vehicleId: 'ID vozila',
        providerName: 'Naziv dobavljača',
        providerId: 'ID dobavljača',
        contractNumber: 'Broj ugovora',
        totalCost: 'Ukupan trošak',
        invoiceNumber: 'Broj fakture',
      },

      // Status labels
      status: {
        Valid: 'Važeća',
        ExpiringSoon: 'Ističe uskoro',
        Expired: 'Istekla',
        Unknown: 'Nepoznato',
      },

      // Actions
      actions: {
        view: 'Pregledaj',
        edit: 'Izmeni',
        delete: 'Obriši',
        create: 'Kreiraj',
      },

      // Dialogs
      deleteConfirmTitle: 'Potvrda brisanja registracije',
      deleteConfirmMessage: 'Da li ste sigurni da želite da obrišete registraciju: {{registrationInfo}}?',
      deleteSuccess: 'Registracija je uspešno obrisana',
      deleteError: 'Greška pri brisanju registracije',

      // Validation messages
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        validFromRequired: 'Datum početka važenja je obavezan',
        validToRequired: 'Datum isteka važenja je obavezan',
        odometerRequired: 'Kilometraža je obavezna',
        odometerNonNegative: 'Kilometraža ne može biti negativna',
        costRequired: 'Trošak je obavezan',
        costNonNegative: 'Trošak ne može biti negativan',
        descriptionRequired: 'Opis je obavezan',
        invoiceNumberRequired: 'Broj fakture je obavezan',
        contractRequired: 'Ugovor je obavezan kada je odabran dobavljač',
        customProviderNameRequired: 'Naziv dobavljača je obavezan kada dobavljač nije odabran',
      },

      // Success messages
      success: {
        created: 'Registracija je uspešno kreirana',
        updated: 'Registracija je uspešno ažurirana',
        deleted: 'Registracija je uspešno obrisana',
      },

      // Error messages
      errors: {
        createFailed: 'Greška pri kreiranju registracije',
        updateFailed: 'Greška pri ažuriranju registracije',
        deleteFailed: 'Greška pri brisanju registracije',
        loadFailed: 'Greška pri učitavanju registracije',
      },
    },
    fuelLogs: {
      title: 'Evidencija goriva',
      add: 'Dodaj unos goriva',
      edit: 'Izmeni unos goriva',
      withoutTravelOrder: 'Bez vožnje',
      viewTrip: 'Pogledaj vožnju',
      viewTravelOrder: 'Pogledaj putni nalog',
      sectionTrip: 'Vožnja',
      sectionTravelOrder: 'Putni nalog',
      tripNumber: 'Broj vožnje',
      travelOrderNumber: 'Broj putnog naloga',
      list: {
        title: 'Gorivo',
        subtitle: 'Pregled svih unosa goriva',
        searchPlaceholder: 'Pretraži po vozilu, stanici, putnom nalogu...',
        allTypes: 'Svi tipovi',
        emptyMessage: 'Nema unetih podataka o gorivu.',
        errorMessage: 'Greška pri učitavanju podataka o gorivu.',
      },
      table: {
        vehicle: 'Vozilo',
        travelOrder: 'Putni nalog',
        odometer: 'Kilometraža',
        pricePerLiter: 'Cena/L',
        total: 'Ukupno',
        station: 'Stanica',
        noOrder: 'Bez naloga',
      },
      delete: {
        title: 'Potvrda brisanja',
        message: 'Da li ste sigurni da želite da obrišete unos goriva: {{info}}?',
      },
      fuelTypes: {
        Other: 'Ostalo',
        Diesel: 'Dizel',
        Petrol: 'Benzin',
        LPG: 'TNG',
        CNG: 'KPG',
        Electric: 'Električna energija',
      },
      fields: {
        date: 'Datum',
        odometerReading: 'Stanje kilometraže',
        fuelType: 'Tip goriva',
        liters: 'Litara',
        pricePerLiter: 'Cena po litri (KM)',
        totalCost: 'Ukupan trošak (KM)',
        fuelStationName: 'Benzinska stanica',
        fuelCardNumber: 'Broj kartice',
        invoiceNumber: 'Broj računa',
        notes: 'Napomene',
      },
      validation: {
        odometerInvalid: 'Unesite validnu vrednost',
        odometerMinimumValue: 'Kilometraža ne može biti 0',
        odometerMinimum: 'Kilometraža mora biti veća ili jednaka {{min}} km',
        odometerMaximum: 'Kilometraža ne može biti veća od {{max}} km',
      },
      warnings: {
        odometerBelowCurrent: 'Upozorenje: Uneta kilometraža ({{entered}} km) je manja od trenutne kilometraže vozila ({{current}} km). Ovo može biti u redu ako unosite istorijske podatke.',
      },
      helpers: {
        odometerRange: 'Minimalno: {{min}} km',
        odometerRangeWithMax: 'Minimalno: {{min}} km, Maksimalno: {{max}} km',
        pricePerLiter: 'Opciono - ako unesete, ukupan trošak će biti automatski izračunat',
        totalCost: 'Obavezno - unesite ukupan trošak ili cenu po litri',
      },
    },
    fleetUsers: {
      title: 'Korisnici voznog parka',
      list: {
        title: 'Korisnici',
        subtitle: 'Pregled korisnika voznog parka',
      },
      detail: {
        title: 'Detalji korisnika',
      },
      create: {
        title: 'Novi korisnik',
        subtitle: 'Dodaj novog korisnika voznog parka',
      },
      edit: {
        title: 'Izmeni korisnika',
        subtitle: 'Izmeni podatke korisnika',
      },
      fields: {
        firstName: 'Ime',
        lastName: 'Prezime',
        email: 'Email',
        driverLicenseNumber: 'Broj vozačke dozvole',
        driverLicenseCategories: 'Kategorije',
        driverLicenseCategoriesHelper: 'Unesite kategorije odvojene zarezom (npr. B, C, D)',
        driverLicenseExpiryDate: 'Datum isteka',
        phoneNumber: 'Telefon',
      },
      tabs: {
        basicInfo: 'Osnovni podaci',
        driverInfo: 'Vozačka dozvola',
        requests: 'Zahtevi',
        travelOrders: 'Vožnje',
      },
      sections: {
        basicInfo: 'Osnovni podaci',
        driverLicense: 'Vozačka dozvola',
        contactInfo: 'Kontakt informacije',
      },
      noRequests: 'Nema zahteva',
      noTravelOrders: 'Nema vožnji',
      createSuccess: 'Korisnik uspešno kreiran',
      updateSuccess: 'Korisnik uspešno ažuriran',
      licenseExpiringSoon: 'Vozačka dozvola ističe uskoro',
      licenseExpired: 'Vozačka dozvola je istekla',
    },
  },
  users: {
    nav: {
      users: 'Korisnici',
      roles: 'Uloge',
      permissions: 'Permisije',
    },
    list: {
      title: 'Korisnici',
      subtitle: 'Upravljanje korisnicima sistema',
    },
    roles: {
      title: 'Uloge',
      subtitle: 'Upravljanje ulogama i dodela korisnicima',
    },
    permissions: {
      title: 'Permisije',
      subtitle: 'Upravljanje permisijama korisnika i uloga',
    },
  },
  assignments: {
    warnings: {
      vehicleAlreadyAssigned: 'Upozorenje: Vozilo je trenutno dodeljeno korisniku {{userName}}. Nova dodela će automatski završiti trenutnu dodelu.',
      vehicleNotFree: 'Vozilo ne može biti dodeljeno jer trenutni status nije Slobodno ili U upotrebi. Trenutni status: {{status}}',
    },
  },
  account: {
    title: 'Moj nalog',
    subtitle: 'Upravljanje nalogom i lozinkom',
    profile: 'Profil',
    userInformation: 'Informacije o korisniku',
    firstName: 'Ime',
    lastName: 'Prezime',
    email: 'Email',
    changePassword: 'Promeni lozinku',
    passwordSection: 'Promena lozinke',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    passwordChanged: 'Lozinka je uspešno promenjena',
    passwordChangeFailed: 'Greška pri promeni lozinke',
    invalidCurrentPassword: 'Trenutna lozinka nije ispravna',
    passwordsDoNotMatch: 'Lozinke se ne poklapaju',
    passwordTooShort: 'Lozinka mora imati najmanje 8 karaktera',
    changePasswordButton: 'Promeni lozinku',
    changingPassword: 'Promena lozinke...',
  },
  apiErrors: {
    // Contract errors
    'Contract.ContractAmountExceeded': 'Iznos prelazi raspoloživa sredstva ugovora.',
    'Contract.ContractTerminated': 'Ugovor je raskinut i ne može se više koristiti.',
    // Travel Order Period errors
    'TravelOrderPeriod.NotFoundForMonth':
      'Putni nalog za vozilo {{vehiclePlate}} u periodu {{period}} nije kreiran. Molimo kreirajte putni nalog pre odobravanja zahtjeva.',
    'TravelOrderPeriod.NotFound': 'Putni nalog nije pronađen.',
    'TravelOrderPeriod.InvalidVehicleId': 'ID vozila je obavezan.',
    'TravelOrderPeriod.InvalidResponsibleEmployeeId': 'ID odgovornog zaposlenog je obavezan.',
    'TravelOrderPeriod.InvalidMonth': 'Mjesec mora biti između 1 i 12.',
    'TravelOrderPeriod.TravelOrderNumberRequired': 'Broj putnog naloga je obavezan.',
    'TravelOrderPeriod.PeriodAlreadyExists': 'Period putnog naloga već postoji za ovo vozilo i mjesec.',
    'TravelOrderPeriod.PeriodNotOpen': 'Period putnog naloga nije otvoren za dodavanje novih vožnji.',
    'TravelOrderPeriod.OverlappingPeriod': 'Period se preklapa sa postojećim periodom za ovo vozilo.',
    'TravelOrderPeriod.VehicleAlreadyHasOpenPeriod': 'Nije moguće kreirati novi period jer vozilo već ima otvoren period. Zatvorite postojeći period prvo.',
    'TravelOrderPeriod.PeriodVehicleMismatch': 'Odabrani period ne pripada ovom vozilu.',
    'TravelOrderPeriod.HasActiveTrips': 'Nije moguće zatvoriti period dok postoje aktivne vožnje.',
    'TravelOrderPeriod.HasNonClosedTrips': 'Nije moguće zatvoriti period dok postoje nezatvorene vožnje. Sve vožnje moraju biti zatvorene ili otkazane.',
    'TravelOrderPeriod.CannotCloseInCurrentStatus': 'Period može biti zatvoren samo kada je otvoren.',
    'TravelOrderPeriod.CannotCancelInCurrentStatus': 'Period može biti otkazan samo kada je otvoren.',
    'TravelOrderPeriod.CancellationReasonRequired': 'Razlog otkazivanja je obavezan.',
    'TravelOrderPeriod.CannotModifyClosedPeriod': 'Nije moguće izmeniti zatvoreni ili otkazani period.',
    'TravelOrderPeriod.RequestCrossesMonthBoundary': 'Datumi zahtjeva moraju biti unutar jednog kalendarskog mjeseca.',
    'TravelOrderPeriod.RequestOutsidePeriod': 'Datumi zahtjeva su izvan granica perioda.',
    'TravelOrderPeriod.EndDateMustBeAfterStartDate': 'Datum završetka mora biti nakon datuma početka.',
    'TravelOrderPeriod.CannotSetEndDateOnNonOpenEndedPeriod': 'Nije moguće postaviti datum završetka na period koji nije otvorenog tipa.',
    'TravelOrderPeriod.StartDateRequired': 'Datum početka je obavezan za otvorene periode.',
    'TravelOrderPeriod.InvalidOdometer': 'Stanje kilometraže mora biti pozitivna vrijednost.',
    'TravelOrderPeriod.EndOdometerLessThanStart': 'Završna kilometraža ne može biti manja od početne.',
    'TravelOrderPeriod.OdometerCannotDecrease': 'Kilometraža ne može biti manja od trenutne vrijednosti.',
    'TravelOrderPeriod.StartOdometerGreaterThanEnd': 'Početna kilometraža ne može biti veća od završne.',
    'TravelOrderPeriod.CannotModifyDatesOnMonthlyPeriod': 'Nije moguće izmeniti datume na mjesečnom periodu.',
    'TravelOrderPeriod.OdometerLessThanLastTrip': 'Završna kilometraža ne može biti manja od kilometraže posljednje vožnje.',
    'TravelOrderPeriod.CannotReopenInCurrentStatus': 'Samo zatvoreni periodi mogu biti ponovo otvoreni.',
    'TravelOrderPeriod.CannotReopenOverlappingPeriod': 'Nije moguće ponovo otvoriti period jer postoji drugi aktivni period za isti vremenski raspon.',
    'TravelOrderPeriod.CannotModifyCancelledPeriod': 'Nije moguće izmeniti otkazani period.',
    'TravelOrderPeriod.CannotCloseBeforeMonthEnds': 'Nije moguće zatvoriti period prije isteka mjeseca.',
    'TravelOrderPeriod.CannotCorrectOdometerInCurrentStatus': 'Kilometraža perioda može biti korigovana samo na zatvorenim periodima.',
    'TravelOrderPeriod.EndOdometerLessThanLastTripEnd': 'Završna kilometraža perioda ({{providedEnd}}) ne može biti manja od najveće završne kilometraže vožnje u periodu ({{maxTripEnd}}).',
    'TravelOrderPeriod.StartOdometerExceedsFirstTripStart': 'Početna kilometraža perioda ({{providedStart}}) ne može biti veća od najmanje početne kilometraže vožnje u periodu ({{minTripStart}}).',
    'TravelOrderPeriod.AtLeastOneOdometerRequired': 'Morate unijeti barem jednu vrijednost: početnu ili završnu kilometražu.',
    'TravelOrderPeriod.HasOpenOrCompletedTrips': 'Nije moguće zatvoriti period jer postoje otvorene ili završene vožnje. Sve vožnje moraju biti zatvorene, otkazane ili u toku (prekogranične).',
    'TravelOrderPeriod.InProgressTripWithoutNextSegment': 'Nije moguće zatvoriti period jer vožnja u toku nema segment u sljedećem periodu. Vožnja mora biti završena ili otkazana.',

    // Vehicle Request errors
    'VehicleRequest.NotFound': 'Zahtjev za vozilo nije pronađen.',
    'VehicleRequest.InvalidVehicleId': 'ID vozila je obavezan.',
    'VehicleRequest.InvalidRequesterId': 'ID podnosioca zahtjeva je obavezan.',
    'VehicleRequest.PurposeRequired': 'Svrha je obavezna za zahtjev za vozilo.',
    'VehicleRequest.InvalidDateRange': 'Datum završetka mora biti nakon datuma početka.',
    'VehicleRequest.StartDateInPast': 'Datum početka ne može biti u prošlosti.',
    'VehicleRequest.VehicleNotAvailable': 'Vozilo nije dostupno za traženi period.',
    'VehicleRequest.AlreadyApproved': 'Zahtjev je već odobren.',
    'VehicleRequest.AlreadyRejected': 'Zahtjev je već odbijen.',
    'VehicleRequest.AlreadyCancelled': 'Zahtjev je već otkazan.',
    'VehicleRequest.CannotApproveNonPending': 'Samo zahtjevi na čekanju mogu biti odobreni.',
    'VehicleRequest.CannotRejectNonPending': 'Samo zahtjevi na čekanju mogu biti odbijeni.',
    'VehicleRequest.CannotCancelInCurrentStatus': 'Zahtjev ne može biti otkazan u trenutnom statusu.',
    'VehicleRequest.CannotCancelApprovedRequest': 'Odobreni zahtjevi ne mogu biti otkazani. Molimo otkažite vožnju umjesto toga.',
    'VehicleRequest.CannotCancelActiveTripRequest':
      'Nije moguće otkazati zahtjev jer je vožnja već u toku ili završena.',
    'VehicleRequest.OverlappingRequest': 'Postoji preklapajući odobren zahtjev za ovo vozilo.',
    'VehicleRequest.InvalidApproverId': 'Nevažeći ID odobravača.',
    'VehicleRequest.RejectionReasonRequired': 'Razlog odbijanja je obavezan.',
    'VehicleRequest.CannotLinkTravelOrderToNonApproved': 'Vožnja može biti povezana samo sa odobrenim zahtjevima.',
    'VehicleRequest.CannotCompleteNonApproved': 'Samo odobreni zahtjevi mogu biti označeni kao završeni.',
    'VehicleRequest.VehicleAssignedToAnotherDriver': 'Ovo vozilo je dodijeljeno drugom vozaču. Samo dodijeljeni vozač ili menadžeri voznog parka mogu ga zahtijevati.',
    'VehicleRequest.VehicleReservationFailed': 'Greška pri rezervaciji vozila tokom procesa odobravanja.',
    'VehicleRequest.TravelOrderCreationFailed': 'Greška pri kreiranju vožnje.',
    'VehicleRequest.VehicleNotAssigned': 'Vozilo mora biti dodijeljeno prije nego što zahtjev može biti odobren.',
    'VehicleRequest.CannotAssignVehicleToNonPending': 'Vozilo može biti dodijeljeno samo zahtjevima na čekanju.',
    'VehicleRequest.VehiclePlateNumberRequired': 'Registarska oznaka vozila je obavezna pri dodjeli vozila.',
    'VehicleRequest.VehicleDescriptionRequired': 'Opis vozila je obavezan pri dodjeli vozila.',

    // Travel Order errors
    'TravelOrder.NotFound': 'Vožnja nije pronađena.',
    'TravelOrder.NotFoundByOrderNumber': 'Vožnja sa navedenim brojem nije pronađena.',
    'TravelOrder.RequestNotApproved': 'Vožnja može biti kreirana samo iz odobrenih zahtjeva.',
    'TravelOrder.TravelOrderNumberRequired': 'Broj vožnje je obavezan.',
    'TravelOrder.VehicleAlreadyInUse': 'Vozilo je već u upotrebi na drugoj vožnji.',
    'TravelOrder.CannotStartInCurrentStatus': 'Vožnja ne može biti pokrenuta u trenutnom statusu.',
    'TravelOrder.CannotEndInCurrentStatus': 'Vožnja ne može biti završena u trenutnom statusu.',
    'TravelOrder.EndOdometerLessThanStart': 'Završna kilometraža ne može biti manja od početne.',
    'TravelOrder.CannotCloseInCurrentStatus': 'Vožnja može biti zatvorena samo kada je završena.',
    'TravelOrder.CannotCancelInCurrentStatus': 'Vožnja može biti otkazana samo kada je otvorena.',
    'TravelOrder.CannotAddFuelLogInCurrentStatus': 'Evidencija goriva može biti dodana samo na vožnje u toku, završene ili zatvorene vožnje.',
    'TravelOrder.CancellationReasonRequired': 'Razlog otkazivanja je obavezan.',
    'TravelOrder.InvalidVehicleId': 'ID vozila je obavezan.',
    'TravelOrder.InvalidDriverId': 'ID vozača je obavezan.',
    'TravelOrder.InvalidOdometer': 'Stanje kilometraže mora biti pozitivna vrijednost.',
    'TravelOrder.VehicleNotAssigned': 'Nije moguće kreirati vožnju bez dodijeljenog vozila.',
    'TravelOrder.OdometerCannotDecrease': 'Kilometraža ne može biti manja od trenutne kilometraže vozila.',
    'TravelOrder.OverlappingTravelOrder': 'Nije moguće kreirati vožnju jer već postoji aktivna vožnja za ovo vozilo u traženom periodu.',
    'TravelOrder.CannotUpdateInCurrentStatus': 'Detalji vožnje mogu biti ažurirani samo kada je otvorena (nije još pokrenuta).',
    'TravelOrder.PeriodIdRequired': 'ID perioda putnog naloga je obavezan.',
    'TravelOrder.InvalidTripNumber': 'Broj vožnje mora biti pozitivan cijeli broj.',
    'TravelOrder.NotAuthorized': 'Nemate dozvolu za ovu akciju na vožnji.',
    'TravelOrder.CannotCorrectOdometerInCurrentStatus': 'Kilometraža može biti korigovana samo na završenim ili zatvorenim vožnjama.',
    'TravelOrder.EndOdometerExceedsPeriodEnd': 'Završna kilometraža vožnje ({{providedEnd}}) ne može biti veća od završne kilometraže zatvorenog perioda ({{periodEnd}}).',
    'TravelOrder.StartOdometerLessThanPeriodStart': 'Početna kilometraža vožnje ({{providedStart}}) ne može biti manja od početne kilometraže zatvorenog perioda ({{periodStart}}).',

    // Vehicle errors
    'Vehicle.NotFound': 'Vozilo nije pronađeno.',
    'Vehicle.InvalidBrand': 'Marka vozila je obavezna.',
    'Vehicle.InvalidModel': 'Model vozila je obavezan.',
    'Vehicle.InvalidPlateNumber': 'Registarska oznaka vozila je obavezna.',
    'Vehicle.PlateNumberAlreadyExists': 'Vozilo sa ovom registracijom već postoji.',
    'Vehicle.InvalidOdometerReading': 'Stanje kilometraže mora biti pozitivna vrijednost.',
    'Vehicle.OdometerCannotDecrease': 'Kilometraža ne može biti manja od trenutne vrijednosti.',
    'Vehicle.InvalidPassengerSeats': 'Broj putničkih sjedišta mora biti pozitivna vrijednost.',
    'Vehicle.InvalidRegistrationDates': 'Datum isteka registracije mora biti nakon datuma registracije.',
    'Vehicle.InvalidFleetUserId': 'ID korisnika voznog parka je obavezan za dodjelu vozača.',
    'Vehicle.InvalidFleetUserName': 'Ime korisnika voznog parka je obavezno za dodjelu vozača.',
    'Vehicle.NoActiveAssignment': 'Nije pronađena aktivna dodjela vozača za ovo vozilo.',
    'Vehicle.NoResponsibleHolderAssigned': 'Vozilo nema dodeljenog nosioca. Dodelite odgovornu osobu pre odobravanja.',
    'Vehicle.InvalidExpectedEndDate': 'Očekivani datum završetka mora biti u budućnosti za dugoročne dodjele.',
    'Vehicle.ExpectedEndDateRequiredForLongTerm': 'Očekivani datum završetka je obavezan za dugoročne dodjele.',
    'Vehicle.InvalidAssignmentType': 'Nevažeći tip dodjele. Mora biti Privremena, Dugoročna ili Stalna.',
    'Vehicle.AlreadyArchived': 'Vozilo je već arhivirano.',
    'Vehicle.CannotArchiveInUse': 'Vozilo ne može biti arhivirano dok je u upotrebi.',
    'Vehicle.InvalidDescription': 'Opis je obavezan.',
    'Vehicle.InvalidCost': 'Trošak mora biti veći od nule.',
    'Vehicle.NotFree': 'Vozilo nije u validnom statusu za ovu operaciju.',
    'Vehicle.NotReserved': 'Vozilo ne može biti označeno kao u upotrebi u trenutnom statusu.',
    'Vehicle.Disposed': 'Vozilo je prodano ili rashodovano i ne može promijeniti status.',
    'Vehicle.NotAvailable': 'Vozilo nije dostupno za traženi period.',
    'Vehicle.AlreadyRegistered': 'Vozilo je već registrovano. Koristite obnovu registracije.',
    'Vehicle.NotRegistered': 'Vozilo nije registrovano. Nije moguće obnoviti registraciju za neregistrovano vozilo.',
    'Vehicle.InvalidRegistrationNumber': 'Broj saobraćajne je obavezan.',
    'Vehicle.OverlappingRegistration': 'Registracija već postoji za ovo vozilo u navedenom periodu.',
    'Vehicle.CannotChangeDriverWithActiveTravelOrders': 'Nije moguće promijeniti dodjelu vozača dok vozilo ima aktivne vožnje.',
    'Vehicle.CannotChangeDriverWithOpenTravelOrderPeriod': 'Nije moguće promijeniti dodjelu vozača dok vozilo ima otvoren period putnog naloga. Zatvorite ili otkažite period prvo.',
    'Vehicle.BlockNotFound': 'Blokada vozila nije pronađena.',
    'Vehicle.InvalidBlockReason': 'Razlog blokade je obavezan.',
    'Vehicle.InvalidBlockDates': 'Datum završetka blokade mora biti nakon datuma početka.',
    'Vehicle.OverlappingBlock': 'Blokada već postoji za ovo vozilo u navedenom periodu.',
    'Vehicle.BlockAlreadyClosed': 'Ova blokada je već zatvorena.',
    'Vehicle.CannotArchiveWithActiveBlocks': 'Vozilo ne može biti arhivirano dok ima aktivne blokade.',
    'Vehicle.HasOverlappingTravelOrder': 'Vozilo ima odobrenu(aktivnu) vožnju u traženom periodu.',
    'Vehicle.HasOverlappingBlock': 'Vozilo je blokirano u traženom periodu.',

    // Fleet User errors
    'FleetUser.NotFound': 'Korisnik voznog parka nije pronađen.',

    // Generic fallback
    default: 'Došlo je do greške. Pokušajte ponovo.',
  },
  tireTracking: {
    nav: 'Evidencija guma',
    title: 'Gume',
    addNew: 'Nova guma',
    searchPlaceholder: 'Pretraži po marki, dimenziji, vozilu...',
    statusFilterLabel: 'Status',
    seasonFilterLabel: 'Sezona',
    allStatuses: 'Svi statusi',
    allSeasons: 'Sve tipove',
    totalCount: 'Ukupno: {{count}} guma',
    errorLoading: 'Greška pri učitavanju guma.',
    emptyMessage: 'Nema guma za prikaz.',
    emptyMessageFiltered: 'Nema guma koje odgovaraju filterima.',
    status: {
      InStorage: 'Na skladištu',
      InUse: 'U upotrebi',
      Disposed: 'Otpisana',
    },
    season: {
      Summer: 'Letnja',
      Winter: 'Zimska',
      AllSeason: 'Sve sezone',
    },
    position: {
      FrontLeft: 'Prednja lijeva',
      FrontRight: 'Prednja desna',
      RearLeft: 'Zadnja lijeva',
      RearRight: 'Zadnja desna',
      RearLeftOuter: 'Zadnja lijeva spoljna',
      RearLeftInner: 'Zadnja lijeva unutrašnja',
      RearRightOuter: 'Zadnja desna spoljna',
      RearRightInner: 'Zadnja desna unutrašnja',
      Spare: 'Rezervna',
    },
    columns: {
      brandModel: 'Marka / Model',
      dimension: 'Dimenzija',
      type: 'Tip',
      status: 'Status',
      vehicle: 'Vozilo',
      position: 'Pozicija',
      dot: 'DOT',
      actions: 'Akcije',
    },
    tooltips: {
      view: 'Prikaži detalje',
      edit: 'Izmijeni podatke gume',
      mount: 'Montiraj na vozilo',
      unmount: 'Skini s vozila',
      editMileage: 'Izmijeni početni km',
      dispose: 'Otpiši',
      reactivate: 'Vrati u skladište',
      delete: 'Obriši',
    },
    fields: {
      brand: 'Marka',
      model: 'Model',
      dimension: 'Dimenzija',
      dimensionHint: 'Dimenzija (npr. 205/55 R16)',
      seasonType: 'Tip sezone',
      dotCode: 'DOT kod',
      purchaseDate: 'Datum kupovine',
      notes: 'Napomena',
      position: 'Pozicija',
      mountDate: 'Datum montaže',
      unmountDate: 'Datum skidanja',
      mileageAtInstall: 'Kilometraža pri montaži',
      mileageAtInstallLabel: 'Kilometraža pri montaži (km)',
      mileageAtRemoval: 'Kilometraža pri skidanju',
      optional: 'Opciono',
      vehicle: 'Vozilo',
      tireFromStorage: 'Guma iz skladišta',
      noTiresInStorage: 'Nema guma u skladištu',
    },
    validation: {
      brandRequired: 'Marka je obavezna',
      dimensionRequired: 'Dimenzija je obavezna',
      mountDateRequired: 'Datum montaže je obavezan',
      unmountDateRequired: 'Datum skidanja je obavezan',
      mileagePositive: 'Kilometraža mora biti pozitivna',
      tireRequired: 'Odabir gume je obavezan',
    },
    create: {
      title: 'Nova guma',
      submit: 'Kreiraj',
      submitting: 'Kreiranje...',
      error: 'Greška prilikom kreiranja gume',
      cancel: 'Otkaži',
    },
    edit: {
      title: 'Izmjena gume',
      submit: 'Sačuvaj',
      submitting: 'Čuvanje...',
      error: 'Greška prilikom izmjene gume',
      cancel: 'Otkaži',
    },
    detail: {
      title: 'Detalji gume',
      brand: 'Marka',
      model: 'Model',
      dimension: 'Dimenzija',
      seasonType: 'Tip sezone',
      dotCode: 'DOT kod',
      purchaseDate: 'Datum nabavke',
      status: 'Status',
      vehicle: 'Vozilo',
      position: 'Pozicija',
      notes: 'Napomena',
      assignmentHistory: 'Istorija montaže',
      neverMounted: 'Guma nije bila montirana.',
      active: 'Aktivna',
      table: {
        vehicle: 'Vozilo',
        position: 'Pozicija',
        installed: 'Montirano',
        removed: 'Skinuto',
        mileageAtInstall: 'km pri montaži',
        mileageAtRemoval: 'km pri skidanju',
      },
    },
    unmount: {
      title: 'Skini gumu s vozila',
      submit: 'Skini gumu',
      submitting: 'Skidanje...',
      error: 'Greška prilikom skidanja gume',
      cancel: 'Otkaži',
    },
    dispose: {
      title: 'Otpiši gumu',
      confirm: 'Da li ste sigurni da želite da otpišete gumu {{tire}}? Guma će biti označena kao otpisana. Istorija montaže ostaje sačuvana.',
      submit: 'Otpiši',
      submitting: 'Otpisivanje...',
      error: 'Greška prilikom otpisa gume',
      cancel: 'Otkaži',
    },
    reactivate: {
      title: 'Vrati gumu u skladište',
      confirm: 'Da li ste sigurni da želite da vratite gumu {{tire}} u skladište? Status gume će biti promijenjen iz "Otpisana" u "Na skladištu".',
      submit: 'Vrati u skladište',
      submitting: 'Vraćanje...',
      error: 'Greška prilikom reaktivacije gume',
      cancel: 'Otkaži',
    },
    editMileage: {
      title: 'Izmijeni početnu kilometražu',
      tireInfo: 'Guma: {{info}}',
      submit: 'Sačuvaj',
      submitting: 'Čuvanje...',
      error: 'Greška prilikom izmjene kilometraže',
      cancel: 'Otkaži',
    },
    mount: {
      title: 'Montiraj gumu',
      submit: 'Montiraj',
      submitting: 'Montaža...',
      error: 'Greška prilikom montaže gume',
      cancel: 'Otkaži',
    },
    mountToVehicle: {
      title: 'Montiraj gumu na vozilo',
      vehicleLabel: 'Vozilo:',
      submit: 'Montiraj',
      submitting: 'Montaža...',
      error: 'Greška prilikom montaže gume',
      cancel: 'Otkaži',
    },
    registerAndMount: {
      title: 'Dodaj novu gumu na vozilo',
      vehicleLabel: 'Vozilo:',
      tireInfoSection: 'Podaci o gumi',
      mountSection: 'Montaža',
      submit: 'Dodaj i montiraj',
      submitting: 'Dodavanje...',
      error: 'Greška prilikom dodavanja gume',
      cancel: 'Otkaži',
    },
  },
  footer: {
    allRightsReserved: 'Sva prava zadržana.',
    support: 'Podrška',
    privacyPolicy: 'Politika privatnosti',
    termsOfUse: 'Uslovi korišćenja',
  },
} as const;
